// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v5.29.3
// source: user-feedback.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { Role, roleFromJSON, roleToJSON } from "./identity";
import Long from "long";

export const protobufPackage = "com.tick2trade.api.userfeedback";

export enum FeedbackCategory {
  CATEGORY_UNKNOWN = 0,
  BUG = 1,
  FEEDBACK = 2,
  UNRECOGNIZED = -1,
}

export function feedbackCategoryFromJSON(object: any): FeedbackCategory {
  switch (object) {
    case 0:
    case "CATEGORY_UNKNOWN":
      return FeedbackCategory.CATEGORY_UNKNOWN;
    case 1:
    case "BUG":
      return FeedbackCategory.BUG;
    case 2:
    case "FEEDBACK":
      return FeedbackCategory.FEEDBACK;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FeedbackCategory.UNRECOGNIZED;
  }
}

export function feedbackCategoryToJSON(object: FeedbackCategory): string {
  switch (object) {
    case FeedbackCategory.CATEGORY_UNKNOWN:
      return "CATEGORY_UNKNOWN";
    case FeedbackCategory.BUG:
      return "BUG";
    case FeedbackCategory.FEEDBACK:
      return "FEEDBACK";
    case FeedbackCategory.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum MediaType {
  MEDIA_TYPE_UNKNOWN = 0,
  IMAGE = 1,
  VIDEO = 2,
  UNRECOGNIZED = -1,
}

export function mediaTypeFromJSON(object: any): MediaType {
  switch (object) {
    case 0:
    case "MEDIA_TYPE_UNKNOWN":
      return MediaType.MEDIA_TYPE_UNKNOWN;
    case 1:
    case "IMAGE":
      return MediaType.IMAGE;
    case 2:
    case "VIDEO":
      return MediaType.VIDEO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MediaType.UNRECOGNIZED;
  }
}

export function mediaTypeToJSON(object: MediaType): string {
  switch (object) {
    case MediaType.MEDIA_TYPE_UNKNOWN:
      return "MEDIA_TYPE_UNKNOWN";
    case MediaType.IMAGE:
      return "IMAGE";
    case MediaType.VIDEO:
      return "VIDEO";
    case MediaType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum SupportConversationStatus {
  SUPPORT_STATUS_UNKNOWN = 0,
  NEEDS_REPLY = 1,
  WAITING_ON_USER = 2,
  RESOLVED = 3,
  UNRECOGNIZED = -1,
}

export function supportConversationStatusFromJSON(object: any): SupportConversationStatus {
  switch (object) {
    case 0:
    case "SUPPORT_STATUS_UNKNOWN":
      return SupportConversationStatus.SUPPORT_STATUS_UNKNOWN;
    case 1:
    case "NEEDS_REPLY":
      return SupportConversationStatus.NEEDS_REPLY;
    case 2:
    case "WAITING_ON_USER":
      return SupportConversationStatus.WAITING_ON_USER;
    case 3:
    case "RESOLVED":
      return SupportConversationStatus.RESOLVED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SupportConversationStatus.UNRECOGNIZED;
  }
}

export function supportConversationStatusToJSON(object: SupportConversationStatus): string {
  switch (object) {
    case SupportConversationStatus.SUPPORT_STATUS_UNKNOWN:
      return "SUPPORT_STATUS_UNKNOWN";
    case SupportConversationStatus.NEEDS_REPLY:
      return "NEEDS_REPLY";
    case SupportConversationStatus.WAITING_ON_USER:
      return "WAITING_ON_USER";
    case SupportConversationStatus.RESOLVED:
      return "RESOLVED";
    case SupportConversationStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface FeedbackMediaItem {
  s3Key: string;
  type: MediaType;
}

export interface SubmitFeedbackRequest {
  category: FeedbackCategory;
  text: string;
  media: FeedbackMediaItem[];
}

export interface SubmitFeedbackResponse {
  id: string;
}

export interface SupportMessageContext {
  route: string;
  userAgent: string;
  appVersion: string;
}

export interface SupportMessageRequest {
  clientMessageId: string;
  body: string;
  category: FeedbackCategory;
  context: SupportMessageContext | undefined;
  media: FeedbackMediaItem[];
}

export interface SupportMediaView {
  type: MediaType;
  viewUrl: string;
}

export interface SupportMessage {
  id: string;
  clientMessageId: string;
  authorRole: Role;
  authorUserId: string;
  authorName: string;
  body: string;
  category: FeedbackCategory;
  context: SupportMessageContext | undefined;
  media: SupportMediaView[];
  created: number;
}

export interface UserSupportConversationSummary {
  id: string;
  category: FeedbackCategory;
  status: SupportConversationStatus;
  preview: string;
  lastMessageAt: number;
  lastMessageAuthor: Role;
  unreadForUser: boolean;
  subject: string;
}

export interface UserSupportConversationList {
  conversations: UserSupportConversationSummary[];
  unreadCount: number;
}

export interface UserSupportConversationDetail {
  conversation: UserSupportConversationSummary | undefined;
  messages: SupportMessage[];
}

export interface UserSupportMessageResult {
  conversation: UserSupportConversationSummary | undefined;
  message: SupportMessage | undefined;
}

export interface SupportMessagesPage {
  messages: SupportMessage[];
}

export interface AdminSupportConversationSummary {
  id: string;
  userId: string;
  userName: string;
  userEmail: string;
  category: FeedbackCategory;
  status: SupportConversationStatus;
  preview: string;
  lastMessageAt: number;
  lastMessageAuthor: Role;
  unreadForAdmin: boolean;
  assigneeUserId: string;
  assigneeName: string;
  userMobile: string;
}

export interface AdminSupportConversationPage {
  conversations: AdminSupportConversationSummary[];
}

export interface AdminSupportConversationDetail {
  conversation: AdminSupportConversationSummary | undefined;
  messages: SupportMessage[];
}

export interface AdminSupportMessageResult {
  conversation: AdminSupportConversationSummary | undefined;
  message: SupportMessage | undefined;
}

export interface SupportNotAssignee {
  assigneeUserId: string;
  assigneeName: string;
}

function createBaseFeedbackMediaItem(): FeedbackMediaItem {
  return { s3Key: "", type: 0 };
}

export const FeedbackMediaItem = {
  encode(message: FeedbackMediaItem, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.s3Key !== "") {
      writer.uint32(10).string(message.s3Key);
    }
    if (message.type !== 0) {
      writer.uint32(16).int32(message.type);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FeedbackMediaItem {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFeedbackMediaItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.s3Key = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FeedbackMediaItem {
    return {
      s3Key: isSet(object.s3Key) ? globalThis.String(object.s3Key) : "",
      type: isSet(object.type) ? mediaTypeFromJSON(object.type) : 0,
    };
  },

  toJSON(message: FeedbackMediaItem): unknown {
    const obj: any = {};
    if (message.s3Key !== "") {
      obj.s3Key = message.s3Key;
    }
    if (message.type !== 0) {
      obj.type = mediaTypeToJSON(message.type);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FeedbackMediaItem>, I>>(base?: I): FeedbackMediaItem {
    return FeedbackMediaItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FeedbackMediaItem>, I>>(object: I): FeedbackMediaItem {
    const message = createBaseFeedbackMediaItem();
    message.s3Key = object.s3Key ?? "";
    message.type = object.type ?? 0;
    return message;
  },
};

function createBaseSubmitFeedbackRequest(): SubmitFeedbackRequest {
  return { category: 0, text: "", media: [] };
}

export const SubmitFeedbackRequest = {
  encode(message: SubmitFeedbackRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.category !== 0) {
      writer.uint32(8).int32(message.category);
    }
    if (message.text !== "") {
      writer.uint32(18).string(message.text);
    }
    for (const v of message.media) {
      FeedbackMediaItem.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SubmitFeedbackRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubmitFeedbackRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.text = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.media.push(FeedbackMediaItem.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubmitFeedbackRequest {
    return {
      category: isSet(object.category) ? feedbackCategoryFromJSON(object.category) : 0,
      text: isSet(object.text) ? globalThis.String(object.text) : "",
      media: globalThis.Array.isArray(object?.media) ? object.media.map((e: any) => FeedbackMediaItem.fromJSON(e)) : [],
    };
  },

  toJSON(message: SubmitFeedbackRequest): unknown {
    const obj: any = {};
    if (message.category !== 0) {
      obj.category = feedbackCategoryToJSON(message.category);
    }
    if (message.text !== "") {
      obj.text = message.text;
    }
    if (message.media?.length) {
      obj.media = message.media.map((e) => FeedbackMediaItem.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubmitFeedbackRequest>, I>>(base?: I): SubmitFeedbackRequest {
    return SubmitFeedbackRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubmitFeedbackRequest>, I>>(object: I): SubmitFeedbackRequest {
    const message = createBaseSubmitFeedbackRequest();
    message.category = object.category ?? 0;
    message.text = object.text ?? "";
    message.media = object.media?.map((e) => FeedbackMediaItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSubmitFeedbackResponse(): SubmitFeedbackResponse {
  return { id: "" };
}

export const SubmitFeedbackResponse = {
  encode(message: SubmitFeedbackResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SubmitFeedbackResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubmitFeedbackResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubmitFeedbackResponse {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: SubmitFeedbackResponse): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubmitFeedbackResponse>, I>>(base?: I): SubmitFeedbackResponse {
    return SubmitFeedbackResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubmitFeedbackResponse>, I>>(object: I): SubmitFeedbackResponse {
    const message = createBaseSubmitFeedbackResponse();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseSupportMessageContext(): SupportMessageContext {
  return { route: "", userAgent: "", appVersion: "" };
}

export const SupportMessageContext = {
  encode(message: SupportMessageContext, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.route !== "") {
      writer.uint32(10).string(message.route);
    }
    if (message.userAgent !== "") {
      writer.uint32(18).string(message.userAgent);
    }
    if (message.appVersion !== "") {
      writer.uint32(26).string(message.appVersion);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SupportMessageContext {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSupportMessageContext();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.route = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.userAgent = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.appVersion = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SupportMessageContext {
    return {
      route: isSet(object.route) ? globalThis.String(object.route) : "",
      userAgent: isSet(object.userAgent) ? globalThis.String(object.userAgent) : "",
      appVersion: isSet(object.appVersion) ? globalThis.String(object.appVersion) : "",
    };
  },

  toJSON(message: SupportMessageContext): unknown {
    const obj: any = {};
    if (message.route !== "") {
      obj.route = message.route;
    }
    if (message.userAgent !== "") {
      obj.userAgent = message.userAgent;
    }
    if (message.appVersion !== "") {
      obj.appVersion = message.appVersion;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SupportMessageContext>, I>>(base?: I): SupportMessageContext {
    return SupportMessageContext.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SupportMessageContext>, I>>(object: I): SupportMessageContext {
    const message = createBaseSupportMessageContext();
    message.route = object.route ?? "";
    message.userAgent = object.userAgent ?? "";
    message.appVersion = object.appVersion ?? "";
    return message;
  },
};

function createBaseSupportMessageRequest(): SupportMessageRequest {
  return { clientMessageId: "", body: "", category: 0, context: undefined, media: [] };
}

export const SupportMessageRequest = {
  encode(message: SupportMessageRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.clientMessageId !== "") {
      writer.uint32(10).string(message.clientMessageId);
    }
    if (message.body !== "") {
      writer.uint32(18).string(message.body);
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.context !== undefined) {
      SupportMessageContext.encode(message.context, writer.uint32(34).fork()).ldelim();
    }
    for (const v of message.media) {
      FeedbackMediaItem.encode(v!, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SupportMessageRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSupportMessageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.clientMessageId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.body = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.context = SupportMessageContext.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.media.push(FeedbackMediaItem.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SupportMessageRequest {
    return {
      clientMessageId: isSet(object.clientMessageId) ? globalThis.String(object.clientMessageId) : "",
      body: isSet(object.body) ? globalThis.String(object.body) : "",
      category: isSet(object.category) ? feedbackCategoryFromJSON(object.category) : 0,
      context: isSet(object.context) ? SupportMessageContext.fromJSON(object.context) : undefined,
      media: globalThis.Array.isArray(object?.media) ? object.media.map((e: any) => FeedbackMediaItem.fromJSON(e)) : [],
    };
  },

  toJSON(message: SupportMessageRequest): unknown {
    const obj: any = {};
    if (message.clientMessageId !== "") {
      obj.clientMessageId = message.clientMessageId;
    }
    if (message.body !== "") {
      obj.body = message.body;
    }
    if (message.category !== 0) {
      obj.category = feedbackCategoryToJSON(message.category);
    }
    if (message.context !== undefined) {
      obj.context = SupportMessageContext.toJSON(message.context);
    }
    if (message.media?.length) {
      obj.media = message.media.map((e) => FeedbackMediaItem.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SupportMessageRequest>, I>>(base?: I): SupportMessageRequest {
    return SupportMessageRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SupportMessageRequest>, I>>(object: I): SupportMessageRequest {
    const message = createBaseSupportMessageRequest();
    message.clientMessageId = object.clientMessageId ?? "";
    message.body = object.body ?? "";
    message.category = object.category ?? 0;
    message.context = (object.context !== undefined && object.context !== null)
      ? SupportMessageContext.fromPartial(object.context)
      : undefined;
    message.media = object.media?.map((e) => FeedbackMediaItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSupportMediaView(): SupportMediaView {
  return { type: 0, viewUrl: "" };
}

export const SupportMediaView = {
  encode(message: SupportMediaView, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.viewUrl !== "") {
      writer.uint32(18).string(message.viewUrl);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SupportMediaView {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSupportMediaView();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.viewUrl = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SupportMediaView {
    return {
      type: isSet(object.type) ? mediaTypeFromJSON(object.type) : 0,
      viewUrl: isSet(object.viewUrl) ? globalThis.String(object.viewUrl) : "",
    };
  },

  toJSON(message: SupportMediaView): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = mediaTypeToJSON(message.type);
    }
    if (message.viewUrl !== "") {
      obj.viewUrl = message.viewUrl;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SupportMediaView>, I>>(base?: I): SupportMediaView {
    return SupportMediaView.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SupportMediaView>, I>>(object: I): SupportMediaView {
    const message = createBaseSupportMediaView();
    message.type = object.type ?? 0;
    message.viewUrl = object.viewUrl ?? "";
    return message;
  },
};

function createBaseSupportMessage(): SupportMessage {
  return {
    id: "",
    clientMessageId: "",
    authorRole: 0,
    authorUserId: "",
    authorName: "",
    body: "",
    category: 0,
    context: undefined,
    media: [],
    created: 0,
  };
}

export const SupportMessage = {
  encode(message: SupportMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.clientMessageId !== "") {
      writer.uint32(18).string(message.clientMessageId);
    }
    if (message.authorRole !== 0) {
      writer.uint32(24).int32(message.authorRole);
    }
    if (message.authorUserId !== "") {
      writer.uint32(34).string(message.authorUserId);
    }
    if (message.authorName !== "") {
      writer.uint32(42).string(message.authorName);
    }
    if (message.body !== "") {
      writer.uint32(50).string(message.body);
    }
    if (message.category !== 0) {
      writer.uint32(56).int32(message.category);
    }
    if (message.context !== undefined) {
      SupportMessageContext.encode(message.context, writer.uint32(66).fork()).ldelim();
    }
    for (const v of message.media) {
      SupportMediaView.encode(v!, writer.uint32(74).fork()).ldelim();
    }
    if (message.created !== 0) {
      writer.uint32(80).int64(message.created);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SupportMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSupportMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.clientMessageId = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.authorRole = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.authorUserId = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.authorName = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.body = reader.string();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.context = SupportMessageContext.decode(reader, reader.uint32());
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.media.push(SupportMediaView.decode(reader, reader.uint32()));
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.created = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SupportMessage {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      clientMessageId: isSet(object.clientMessageId) ? globalThis.String(object.clientMessageId) : "",
      authorRole: isSet(object.authorRole) ? roleFromJSON(object.authorRole) : 0,
      authorUserId: isSet(object.authorUserId) ? globalThis.String(object.authorUserId) : "",
      authorName: isSet(object.authorName) ? globalThis.String(object.authorName) : "",
      body: isSet(object.body) ? globalThis.String(object.body) : "",
      category: isSet(object.category) ? feedbackCategoryFromJSON(object.category) : 0,
      context: isSet(object.context) ? SupportMessageContext.fromJSON(object.context) : undefined,
      media: globalThis.Array.isArray(object?.media) ? object.media.map((e: any) => SupportMediaView.fromJSON(e)) : [],
      created: isSet(object.created) ? globalThis.Number(object.created) : 0,
    };
  },

  toJSON(message: SupportMessage): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.clientMessageId !== "") {
      obj.clientMessageId = message.clientMessageId;
    }
    if (message.authorRole !== 0) {
      obj.authorRole = roleToJSON(message.authorRole);
    }
    if (message.authorUserId !== "") {
      obj.authorUserId = message.authorUserId;
    }
    if (message.authorName !== "") {
      obj.authorName = message.authorName;
    }
    if (message.body !== "") {
      obj.body = message.body;
    }
    if (message.category !== 0) {
      obj.category = feedbackCategoryToJSON(message.category);
    }
    if (message.context !== undefined) {
      obj.context = SupportMessageContext.toJSON(message.context);
    }
    if (message.media?.length) {
      obj.media = message.media.map((e) => SupportMediaView.toJSON(e));
    }
    if (message.created !== 0) {
      obj.created = Math.round(message.created);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SupportMessage>, I>>(base?: I): SupportMessage {
    return SupportMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SupportMessage>, I>>(object: I): SupportMessage {
    const message = createBaseSupportMessage();
    message.id = object.id ?? "";
    message.clientMessageId = object.clientMessageId ?? "";
    message.authorRole = object.authorRole ?? 0;
    message.authorUserId = object.authorUserId ?? "";
    message.authorName = object.authorName ?? "";
    message.body = object.body ?? "";
    message.category = object.category ?? 0;
    message.context = (object.context !== undefined && object.context !== null)
      ? SupportMessageContext.fromPartial(object.context)
      : undefined;
    message.media = object.media?.map((e) => SupportMediaView.fromPartial(e)) || [];
    message.created = object.created ?? 0;
    return message;
  },
};

function createBaseUserSupportConversationSummary(): UserSupportConversationSummary {
  return { id: "", category: 0, status: 0, preview: "", lastMessageAt: 0, lastMessageAuthor: 0, unreadForUser: false, subject: "" };
}

export const UserSupportConversationSummary = {
  encode(message: UserSupportConversationSummary, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.category !== 0) {
      writer.uint32(16).int32(message.category);
    }
    if (message.status !== 0) {
      writer.uint32(24).int32(message.status);
    }
    if (message.preview !== "") {
      writer.uint32(34).string(message.preview);
    }
    if (message.lastMessageAt !== 0) {
      writer.uint32(40).int64(message.lastMessageAt);
    }
    if (message.lastMessageAuthor !== 0) {
      writer.uint32(48).int32(message.lastMessageAuthor);
    }
    if (message.unreadForUser !== false) {
      writer.uint32(56).bool(message.unreadForUser);
    }
    if (message.subject !== "") {
      writer.uint32(66).string(message.subject);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserSupportConversationSummary {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserSupportConversationSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.preview = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.lastMessageAt = longToNumber(reader.int64() as Long);
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.lastMessageAuthor = reader.int32() as any;
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.unreadForUser = reader.bool();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.subject = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserSupportConversationSummary {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      category: isSet(object.category) ? feedbackCategoryFromJSON(object.category) : 0,
      status: isSet(object.status) ? supportConversationStatusFromJSON(object.status) : 0,
      preview: isSet(object.preview) ? globalThis.String(object.preview) : "",
      lastMessageAt: isSet(object.lastMessageAt) ? globalThis.Number(object.lastMessageAt) : 0,
      lastMessageAuthor: isSet(object.lastMessageAuthor) ? roleFromJSON(object.lastMessageAuthor) : 0,
      unreadForUser: isSet(object.unreadForUser) ? globalThis.Boolean(object.unreadForUser) : false,
      subject: isSet(object.subject) ? globalThis.String(object.subject) : "",
    };
  },

  toJSON(message: UserSupportConversationSummary): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.category !== 0) {
      obj.category = feedbackCategoryToJSON(message.category);
    }
    if (message.status !== 0) {
      obj.status = supportConversationStatusToJSON(message.status);
    }
    if (message.preview !== "") {
      obj.preview = message.preview;
    }
    if (message.lastMessageAt !== 0) {
      obj.lastMessageAt = Math.round(message.lastMessageAt);
    }
    if (message.lastMessageAuthor !== 0) {
      obj.lastMessageAuthor = roleToJSON(message.lastMessageAuthor);
    }
    if (message.unreadForUser !== false) {
      obj.unreadForUser = message.unreadForUser;
    }
    if (message.subject !== "") {
      obj.subject = message.subject;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserSupportConversationSummary>, I>>(base?: I): UserSupportConversationSummary {
    return UserSupportConversationSummary.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserSupportConversationSummary>, I>>(
    object: I,
  ): UserSupportConversationSummary {
    const message = createBaseUserSupportConversationSummary();
    message.id = object.id ?? "";
    message.category = object.category ?? 0;
    message.status = object.status ?? 0;
    message.preview = object.preview ?? "";
    message.lastMessageAt = object.lastMessageAt ?? 0;
    message.lastMessageAuthor = object.lastMessageAuthor ?? 0;
    message.unreadForUser = object.unreadForUser ?? false;
    message.subject = object.subject ?? "";
    return message;
  },
};

function createBaseUserSupportConversationList(): UserSupportConversationList {
  return { conversations: [], unreadCount: 0 };
}

export const UserSupportConversationList = {
  encode(message: UserSupportConversationList, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.conversations) {
      UserSupportConversationSummary.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.unreadCount !== 0) {
      writer.uint32(16).int64(message.unreadCount);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserSupportConversationList {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserSupportConversationList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.conversations.push(UserSupportConversationSummary.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.unreadCount = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserSupportConversationList {
    return {
      conversations: globalThis.Array.isArray(object?.conversations)
        ? object.conversations.map((e: any) => UserSupportConversationSummary.fromJSON(e))
        : [],
      unreadCount: isSet(object.unreadCount) ? globalThis.Number(object.unreadCount) : 0,
    };
  },

  toJSON(message: UserSupportConversationList): unknown {
    const obj: any = {};
    if (message.conversations?.length) {
      obj.conversations = message.conversations.map((e) => UserSupportConversationSummary.toJSON(e));
    }
    if (message.unreadCount !== 0) {
      obj.unreadCount = Math.round(message.unreadCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserSupportConversationList>, I>>(base?: I): UserSupportConversationList {
    return UserSupportConversationList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserSupportConversationList>, I>>(object: I): UserSupportConversationList {
    const message = createBaseUserSupportConversationList();
    message.conversations = object.conversations?.map((e) => UserSupportConversationSummary.fromPartial(e)) || [];
    message.unreadCount = object.unreadCount ?? 0;
    return message;
  },
};

function createBaseUserSupportConversationDetail(): UserSupportConversationDetail {
  return { conversation: undefined, messages: [] };
}

export const UserSupportConversationDetail = {
  encode(message: UserSupportConversationDetail, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.conversation !== undefined) {
      UserSupportConversationSummary.encode(message.conversation, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.messages) {
      SupportMessage.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserSupportConversationDetail {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserSupportConversationDetail();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.conversation = UserSupportConversationSummary.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.messages.push(SupportMessage.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserSupportConversationDetail {
    return {
      conversation: isSet(object.conversation)
        ? UserSupportConversationSummary.fromJSON(object.conversation)
        : undefined,
      messages: globalThis.Array.isArray(object?.messages)
        ? object.messages.map((e: any) => SupportMessage.fromJSON(e))
        : [],
    };
  },

  toJSON(message: UserSupportConversationDetail): unknown {
    const obj: any = {};
    if (message.conversation !== undefined) {
      obj.conversation = UserSupportConversationSummary.toJSON(message.conversation);
    }
    if (message.messages?.length) {
      obj.messages = message.messages.map((e) => SupportMessage.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserSupportConversationDetail>, I>>(base?: I): UserSupportConversationDetail {
    return UserSupportConversationDetail.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserSupportConversationDetail>, I>>(
    object: I,
  ): UserSupportConversationDetail {
    const message = createBaseUserSupportConversationDetail();
    message.conversation = (object.conversation !== undefined && object.conversation !== null)
      ? UserSupportConversationSummary.fromPartial(object.conversation)
      : undefined;
    message.messages = object.messages?.map((e) => SupportMessage.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUserSupportMessageResult(): UserSupportMessageResult {
  return { conversation: undefined, message: undefined };
}

export const UserSupportMessageResult = {
  encode(message: UserSupportMessageResult, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.conversation !== undefined) {
      UserSupportConversationSummary.encode(message.conversation, writer.uint32(10).fork()).ldelim();
    }
    if (message.message !== undefined) {
      SupportMessage.encode(message.message, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserSupportMessageResult {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserSupportMessageResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.conversation = UserSupportConversationSummary.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.message = SupportMessage.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserSupportMessageResult {
    return {
      conversation: isSet(object.conversation)
        ? UserSupportConversationSummary.fromJSON(object.conversation)
        : undefined,
      message: isSet(object.message) ? SupportMessage.fromJSON(object.message) : undefined,
    };
  },

  toJSON(message: UserSupportMessageResult): unknown {
    const obj: any = {};
    if (message.conversation !== undefined) {
      obj.conversation = UserSupportConversationSummary.toJSON(message.conversation);
    }
    if (message.message !== undefined) {
      obj.message = SupportMessage.toJSON(message.message);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserSupportMessageResult>, I>>(base?: I): UserSupportMessageResult {
    return UserSupportMessageResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserSupportMessageResult>, I>>(object: I): UserSupportMessageResult {
    const message = createBaseUserSupportMessageResult();
    message.conversation = (object.conversation !== undefined && object.conversation !== null)
      ? UserSupportConversationSummary.fromPartial(object.conversation)
      : undefined;
    message.message = (object.message !== undefined && object.message !== null)
      ? SupportMessage.fromPartial(object.message)
      : undefined;
    return message;
  },
};

function createBaseSupportMessagesPage(): SupportMessagesPage {
  return { messages: [] };
}

export const SupportMessagesPage = {
  encode(message: SupportMessagesPage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.messages) {
      SupportMessage.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SupportMessagesPage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSupportMessagesPage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.messages.push(SupportMessage.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SupportMessagesPage {
    return {
      messages: globalThis.Array.isArray(object?.messages)
        ? object.messages.map((e: any) => SupportMessage.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SupportMessagesPage): unknown {
    const obj: any = {};
    if (message.messages?.length) {
      obj.messages = message.messages.map((e) => SupportMessage.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SupportMessagesPage>, I>>(base?: I): SupportMessagesPage {
    return SupportMessagesPage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SupportMessagesPage>, I>>(object: I): SupportMessagesPage {
    const message = createBaseSupportMessagesPage();
    message.messages = object.messages?.map((e) => SupportMessage.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAdminSupportConversationSummary(): AdminSupportConversationSummary {
  return {
    id: "",
    userId: "",
    userName: "",
    userEmail: "",
    category: 0,
    status: 0,
    preview: "",
    lastMessageAt: 0,
    lastMessageAuthor: 0,
    unreadForAdmin: false,
    assigneeUserId: "",
    assigneeName: "",
    userMobile: "",
  };
}

export const AdminSupportConversationSummary = {
  encode(message: AdminSupportConversationSummary, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.userId !== "") {
      writer.uint32(18).string(message.userId);
    }
    if (message.userName !== "") {
      writer.uint32(26).string(message.userName);
    }
    if (message.userEmail !== "") {
      writer.uint32(34).string(message.userEmail);
    }
    if (message.category !== 0) {
      writer.uint32(40).int32(message.category);
    }
    if (message.status !== 0) {
      writer.uint32(48).int32(message.status);
    }
    if (message.preview !== "") {
      writer.uint32(58).string(message.preview);
    }
    if (message.lastMessageAt !== 0) {
      writer.uint32(64).int64(message.lastMessageAt);
    }
    if (message.lastMessageAuthor !== 0) {
      writer.uint32(72).int32(message.lastMessageAuthor);
    }
    if (message.unreadForAdmin !== false) {
      writer.uint32(80).bool(message.unreadForAdmin);
    }
    if (message.assigneeUserId !== "") {
      writer.uint32(90).string(message.assigneeUserId);
    }
    if (message.assigneeName !== "") {
      writer.uint32(98).string(message.assigneeName);
    }
    if (message.userMobile !== "") {
      writer.uint32(106).string(message.userMobile);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AdminSupportConversationSummary {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminSupportConversationSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.userName = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.userEmail = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.preview = reader.string();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.lastMessageAt = longToNumber(reader.int64() as Long);
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.lastMessageAuthor = reader.int32() as any;
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.unreadForAdmin = reader.bool();
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.assigneeUserId = reader.string();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.assigneeName = reader.string();
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.userMobile = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminSupportConversationSummary {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      userName: isSet(object.userName) ? globalThis.String(object.userName) : "",
      userEmail: isSet(object.userEmail) ? globalThis.String(object.userEmail) : "",
      category: isSet(object.category) ? feedbackCategoryFromJSON(object.category) : 0,
      status: isSet(object.status) ? supportConversationStatusFromJSON(object.status) : 0,
      preview: isSet(object.preview) ? globalThis.String(object.preview) : "",
      lastMessageAt: isSet(object.lastMessageAt) ? globalThis.Number(object.lastMessageAt) : 0,
      lastMessageAuthor: isSet(object.lastMessageAuthor) ? roleFromJSON(object.lastMessageAuthor) : 0,
      unreadForAdmin: isSet(object.unreadForAdmin) ? globalThis.Boolean(object.unreadForAdmin) : false,
      assigneeUserId: isSet(object.assigneeUserId) ? globalThis.String(object.assigneeUserId) : "",
      assigneeName: isSet(object.assigneeName) ? globalThis.String(object.assigneeName) : "",
      userMobile: isSet(object.userMobile) ? globalThis.String(object.userMobile) : "",
    };
  },

  toJSON(message: AdminSupportConversationSummary): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.userName !== "") {
      obj.userName = message.userName;
    }
    if (message.userEmail !== "") {
      obj.userEmail = message.userEmail;
    }
    if (message.category !== 0) {
      obj.category = feedbackCategoryToJSON(message.category);
    }
    if (message.status !== 0) {
      obj.status = supportConversationStatusToJSON(message.status);
    }
    if (message.preview !== "") {
      obj.preview = message.preview;
    }
    if (message.lastMessageAt !== 0) {
      obj.lastMessageAt = Math.round(message.lastMessageAt);
    }
    if (message.lastMessageAuthor !== 0) {
      obj.lastMessageAuthor = roleToJSON(message.lastMessageAuthor);
    }
    if (message.unreadForAdmin !== false) {
      obj.unreadForAdmin = message.unreadForAdmin;
    }
    if (message.assigneeUserId !== "") {
      obj.assigneeUserId = message.assigneeUserId;
    }
    if (message.assigneeName !== "") {
      obj.assigneeName = message.assigneeName;
    }
    if (message.userMobile !== "") {
      obj.userMobile = message.userMobile;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminSupportConversationSummary>, I>>(base?: I): AdminSupportConversationSummary {
    return AdminSupportConversationSummary.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminSupportConversationSummary>, I>>(
    object: I,
  ): AdminSupportConversationSummary {
    const message = createBaseAdminSupportConversationSummary();
    message.id = object.id ?? "";
    message.userId = object.userId ?? "";
    message.userName = object.userName ?? "";
    message.userEmail = object.userEmail ?? "";
    message.category = object.category ?? 0;
    message.status = object.status ?? 0;
    message.preview = object.preview ?? "";
    message.lastMessageAt = object.lastMessageAt ?? 0;
    message.lastMessageAuthor = object.lastMessageAuthor ?? 0;
    message.unreadForAdmin = object.unreadForAdmin ?? false;
    message.assigneeUserId = object.assigneeUserId ?? "";
    message.assigneeName = object.assigneeName ?? "";
    message.userMobile = object.userMobile ?? "";
    return message;
  },
};

function createBaseAdminSupportConversationPage(): AdminSupportConversationPage {
  return { conversations: [] };
}

export const AdminSupportConversationPage = {
  encode(message: AdminSupportConversationPage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.conversations) {
      AdminSupportConversationSummary.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AdminSupportConversationPage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminSupportConversationPage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.conversations.push(AdminSupportConversationSummary.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminSupportConversationPage {
    return {
      conversations: globalThis.Array.isArray(object?.conversations)
        ? object.conversations.map((e: any) => AdminSupportConversationSummary.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AdminSupportConversationPage): unknown {
    const obj: any = {};
    if (message.conversations?.length) {
      obj.conversations = message.conversations.map((e) => AdminSupportConversationSummary.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminSupportConversationPage>, I>>(base?: I): AdminSupportConversationPage {
    return AdminSupportConversationPage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminSupportConversationPage>, I>>(object: I): AdminSupportConversationPage {
    const message = createBaseAdminSupportConversationPage();
    message.conversations = object.conversations?.map((e) => AdminSupportConversationSummary.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAdminSupportConversationDetail(): AdminSupportConversationDetail {
  return { conversation: undefined, messages: [] };
}

export const AdminSupportConversationDetail = {
  encode(message: AdminSupportConversationDetail, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.conversation !== undefined) {
      AdminSupportConversationSummary.encode(message.conversation, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.messages) {
      SupportMessage.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AdminSupportConversationDetail {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminSupportConversationDetail();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.conversation = AdminSupportConversationSummary.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.messages.push(SupportMessage.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminSupportConversationDetail {
    return {
      conversation: isSet(object.conversation)
        ? AdminSupportConversationSummary.fromJSON(object.conversation)
        : undefined,
      messages: globalThis.Array.isArray(object?.messages)
        ? object.messages.map((e: any) => SupportMessage.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AdminSupportConversationDetail): unknown {
    const obj: any = {};
    if (message.conversation !== undefined) {
      obj.conversation = AdminSupportConversationSummary.toJSON(message.conversation);
    }
    if (message.messages?.length) {
      obj.messages = message.messages.map((e) => SupportMessage.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminSupportConversationDetail>, I>>(base?: I): AdminSupportConversationDetail {
    return AdminSupportConversationDetail.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminSupportConversationDetail>, I>>(
    object: I,
  ): AdminSupportConversationDetail {
    const message = createBaseAdminSupportConversationDetail();
    message.conversation = (object.conversation !== undefined && object.conversation !== null)
      ? AdminSupportConversationSummary.fromPartial(object.conversation)
      : undefined;
    message.messages = object.messages?.map((e) => SupportMessage.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAdminSupportMessageResult(): AdminSupportMessageResult {
  return { conversation: undefined, message: undefined };
}

export const AdminSupportMessageResult = {
  encode(message: AdminSupportMessageResult, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.conversation !== undefined) {
      AdminSupportConversationSummary.encode(message.conversation, writer.uint32(10).fork()).ldelim();
    }
    if (message.message !== undefined) {
      SupportMessage.encode(message.message, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AdminSupportMessageResult {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminSupportMessageResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.conversation = AdminSupportConversationSummary.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.message = SupportMessage.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminSupportMessageResult {
    return {
      conversation: isSet(object.conversation)
        ? AdminSupportConversationSummary.fromJSON(object.conversation)
        : undefined,
      message: isSet(object.message) ? SupportMessage.fromJSON(object.message) : undefined,
    };
  },

  toJSON(message: AdminSupportMessageResult): unknown {
    const obj: any = {};
    if (message.conversation !== undefined) {
      obj.conversation = AdminSupportConversationSummary.toJSON(message.conversation);
    }
    if (message.message !== undefined) {
      obj.message = SupportMessage.toJSON(message.message);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminSupportMessageResult>, I>>(base?: I): AdminSupportMessageResult {
    return AdminSupportMessageResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminSupportMessageResult>, I>>(object: I): AdminSupportMessageResult {
    const message = createBaseAdminSupportMessageResult();
    message.conversation = (object.conversation !== undefined && object.conversation !== null)
      ? AdminSupportConversationSummary.fromPartial(object.conversation)
      : undefined;
    message.message = (object.message !== undefined && object.message !== null)
      ? SupportMessage.fromPartial(object.message)
      : undefined;
    return message;
  },
};

function createBaseSupportNotAssignee(): SupportNotAssignee {
  return { assigneeUserId: "", assigneeName: "" };
}

export const SupportNotAssignee = {
  encode(message: SupportNotAssignee, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.assigneeUserId !== "") {
      writer.uint32(10).string(message.assigneeUserId);
    }
    if (message.assigneeName !== "") {
      writer.uint32(18).string(message.assigneeName);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SupportNotAssignee {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSupportNotAssignee();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.assigneeUserId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.assigneeName = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SupportNotAssignee {
    return {
      assigneeUserId: isSet(object.assigneeUserId) ? globalThis.String(object.assigneeUserId) : "",
      assigneeName: isSet(object.assigneeName) ? globalThis.String(object.assigneeName) : "",
    };
  },

  toJSON(message: SupportNotAssignee): unknown {
    const obj: any = {};
    if (message.assigneeUserId !== "") {
      obj.assigneeUserId = message.assigneeUserId;
    }
    if (message.assigneeName !== "") {
      obj.assigneeName = message.assigneeName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SupportNotAssignee>, I>>(base?: I): SupportNotAssignee {
    return SupportNotAssignee.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SupportNotAssignee>, I>>(object: I): SupportNotAssignee {
    const message = createBaseSupportNotAssignee();
    message.assigneeUserId = object.assigneeUserId ?? "";
    message.assigneeName = object.assigneeName ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
